import { useCustomerAgentHover } from '../../contexts/CustomerAgentHoverContext';
import { LEFT_ALIGNED } from '../constants/WidgetLocations';
import { FocusScope } from 'react-aria';
import styled from 'styled-components';
import { useInitialPromptsAccessibility } from '../../hooks/useInitialPromptsAccessibility';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledInitialPageContentWrapper = styled.div.withConfig({
  displayName: "InitialPageContentWrapper__StyledInitialPageContentWrapper"
})(["display:flex;flex-direction:column;gap:8px;align-items:", ";margin:", ";"], ({
  widgetLocation
}) => widgetLocation === LEFT_ALIGNED ? 'flex-start' : 'flex-end', ({
  showPillLauncher,
  isMobile
}) => {
  if (isMobile) {
    return '0px';
  }
  if (showPillLauncher) {
    return '15px';
  }
  return '18px';
});
const InitialPageContentWrapper = ({
  children,
  widgetLocation,
  showPillLauncher,
  shouldTrapFocus,
  isMobile = false
}) => {
  const {
    setIsHoverActive
  } = useCustomerAgentHover();
  const {
    interactionProps,
    shouldContainFocus
  } = useInitialPromptsAccessibility({
    shouldTrapFocus,
    onHoverChange: setIsHoverActive
  });
  return /*#__PURE__*/_jsx(StyledInitialPageContentWrapper, Object.assign({
    "data-test-id": "initial-page-content-wrapper"
  }, interactionProps, {
    widgetLocation: widgetLocation,
    showPillLauncher: showPillLauncher,
    isMobile: isMobile,
    children: /*#__PURE__*/_jsx(FocusScope, {
      contain: shouldContainFocus,
      restoreFocus: true,
      children: children
    })
  }));
};
InitialPageContentWrapper.displayName = 'InitialPageContentWrapper';
export default InitialPageContentWrapper;